var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contentPage errorTips"},[_c('div',{staticClass:"imgBox"},[_c('img',{attrs:{"src":require("../../assets/images/linkInvalid.jpg"),"alt":""}}),_c('p',[_vm._v("链接已失效")])])])
}]

export { render, staticRenderFns }